import AuthGate from './components/AuthGate';
import AuthenticatedApp from './components/AuthenticatedApp';
import { AppSettingsProvider } from './context/AppSettingsContext';
import { UserProvider } from './context/UserContext';
import { SoundPacksProvider } from './context/SoundPacksContext';
import AuthActionPage, { AUTH_ACTION_PATH } from './components/auth/AuthActionPage';

function App() {
  // Firebase's emailed auth links land here, often signed out — keep it clear
  // of AuthGate and the user-data providers.
  if (window.location.pathname === AUTH_ACTION_PATH) {
    return <AuthActionPage />;
  }

  return (
    <AppSettingsProvider>
      <UserProvider>
        <SoundPacksProvider>
          <AuthGate>
            <AuthenticatedApp />
          </AuthGate>
        </SoundPacksProvider>
      </UserProvider>
    </AppSettingsProvider>
  );
}

export default App;
